export default __webpack_public_path__ + "static/media/KOD0056-min.bed17063.webp";